import { create } from "zustand";
import type { VariationFilter } from "@/lib/liquidity-filter";

type VariationState = {
  variation: VariationFilter;
  setToPHEX: () => void;
  setToEHEX: () => void;
  setToBoth: () => void;
};

export const useVariation = create<VariationState>((set) => ({
  variation: "EHEX & PHEX",
  setToPHEX: () => set({ variation: "PHEX" }),
  setToEHEX: () => set({ variation: "EHEX" }),
  setToBoth: () => set({ variation: "EHEX & PHEX" }),
}));
